import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [value, setValue] = React.useState(0);
  const { labels = [], changeTab, tabWidth } = props;
  const handleChange = (event, newValue) => {
    setValue(newValue);
    changeTab?.(newValue);
  };

  const tabStyles = {
    indicator: {
      width: "33.33%",
    },
  };

  return (
    <Box sx={{ width: "100%"}}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", width: tabWidth ? "24%" : "46%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={tabStyles}
        >
          {labels?.map((label, index) => {
            return <Tab label={label} {...a11yProps(index)} style={{marginRight: "50px", textTransform: "capitalize", fontSize: "17px"}}/>;
          })}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}></CustomTabPanel>
      <CustomTabPanel value={value} index={1}></CustomTabPanel>
      <CustomTabPanel value={value} index={2}></CustomTabPanel>
    </Box>
  );
}

BasicTabs.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  changeTab: PropTypes.func,
  tabWidth: PropTypes.bool,
};
